export const CONSTANTS = {
  DEFAULT_CLUB_PK: 'tw7kxtt',
  SB_PREVIEW_TENANT_KEY: (stage) => {
    if (stage === 'live') {
      // Preview on Live needs to be done on Discovery since Admin will be exclusive to the Ark after SSO implementation
      return 'emerald-works'
    }
    return 'admin'
  },
  DEFAULT_CLUB_TENANT_KEY: 'members',
  DEFAULT_ADMIN_PK: 'to5iscl',
  DEFAULT_ADMIN_TENANT_KEY: 'admin'
}

export const AWS_REGIONS = {
  london: 'eu-west-2',
  california: 'us-west-1',
  singapore: 'ap-southeast-1',
  sydney: 'ap-southeast-2',
  ireland: 'eu-west-1',
  saoPaulo: 'sa-east-1'
}

export const TOOLKIT_TYPE = {
  enterprise: 'ENTERPRISE',
  club: 'CLUB',
  smallBusinessToolkit: 'SMALL_BUSINESS_TOOLKIT'
}
